package com.sddamico.swigmore.ds

import com.varabyte.kobweb.compose.ui.Modifier

/** Swigmore Poll — radii and surface effects. */
object SwEffects {
  const val radiusXs = "4px"
  const val radiusSm = "6px"
  const val radiusMd = "8px"
  const val radiusCard = "9px"
  const val radiusLg = "10px"
  const val radiusXl = "14px"
  const val radiusPill = "999px"
}

/**
 * The signature dashed "ticket stitch" — a dashed outline drawn inside the card edge.
 * [inset] is how far in from the edge (the design uses 5–8px depending on card size).
 */
fun Modifier.stitch(color: String = SwColor.stitch, inset: String = "5px") = css(
  "outline" to "1.5px dashed $color",
  "outline-offset" to "-$inset",
)
